import {
  IconLayoutDashboard,
  IconUsers,
  IconSettings,
  IconHelpCircle,
  IconUsersGroup,
  IconPackage,
  IconCategory,
  IconHome,
  IconBuildingFactory,
  IconBriefcase,
  IconCertificate,
  IconMail,
  IconUserCheck,
  IconWorld,
  IconPhoto,
  IconSearch,
  IconFileText,
  IconPhotoSearch,
  IconArticle
} from '@tabler/icons-react'
import { Hammer } from 'lucide-react'
import { type SidebarData } from '../types'

export const sidebarData: SidebarData = {
  user: {
    name: 'Admin',
    email: 'admin@skgmetal.com',
    avatar: '/avatars/shadcn.jpg',
  },
  teams: [
    {
      name: 'SKG Metal Yönetim',
      logo: Hammer,
      plan: 'Enterprise',
    }
  ],
  navGroups: [
    {
      title: 'Yönetim',
      items: [
        {
          title: 'Dashboard',
          url: '/',
          icon: IconLayoutDashboard,
        },
        {
          title: 'Medya Kütüphanesi',
          url: '/medya',
          icon: IconPhotoSearch,
        },
      ],
    },
    {
      title: 'Katalog',
      items: [
        {
          title: 'Ürünler',
          url: '/urunler',
          icon: IconPackage,
        },
        {
          title: 'Kategoriler',
          url: '/kategoriler',
          icon: IconCategory,
        },
      ],
    },
    {
      title: 'Haber & İçerik',
      items: [
        {
          title: 'Blog Yönetimi',
          url: '/blog',
          icon: IconArticle,
        },
        {
          title: 'İçerik Sayfaları (KVKK vb.)',
          url: '/sayfalar',
          icon: IconFileText,
        },
        {
          title: 'SSS',
          url: '/sss',
          icon: IconHelpCircle,
        },
      ],
    },
    {
      title: 'Kurumsal',
      items: [
        {
          title: 'Hero Slider',
          url: '/hero-slider',
          icon: IconPhoto,
        },
        {
          title: 'Hakkımızda & İstatistikler',
          url: '/hakkimizda',
          icon: IconBuildingFactory,
        },
        {
          title: 'Markalar & Partnerler',
          url: '/referanslar',
          icon: IconBriefcase,
        },
        {
          title: 'Üretim Süreci',
          url: '/uretim-sureci',
          icon: IconHome,
        },
        {
          title: 'Mühendislik & ARG-E',
          url: '/muhendislik',
          icon: IconSettings,
        },
        {
          title: 'Sektörler & Çözümler',
          url: '/sektorler',
          icon: IconWorld,
        },
        {
          title: 'Ekibimiz',
          url: '/ekip',
          icon: IconUsersGroup,
        },
        {
          title: 'Küresel Erişim (Harita)',
          url: '/global-harita',
          icon: IconWorld,
        },
        {
          title: 'Sertifikalar',
          url: '/sertifikalar',
          icon: IconCertificate,
        },
      ],
    },
    {
      title: 'İletişim & IK',
      items: [
        {
          title: 'İletişim Mesajları',
          url: '/iletisim-mesajlari',
          icon: IconMail,
          badge: '3',
        },
        {
          title: 'İş İlanları',
          url: '/is-ilanlari',
          icon: IconBriefcase,
        },
        {
          title: 'Başvurular',
          url: '/basvurular',
          icon: IconUserCheck,
        },
      ],
    },
    {
      title: 'Sistem',
      items: [
        {
          title: 'Sayfa SEO Yönetimi',
          url: '/sayfa-seo',
          icon: IconSearch,
          allowedRoles: ['super_admin'],
        },
        {
          title: 'Site Genel Ayarları',
          url: '/site-ayarlari',
          icon: IconSettings,
          allowedRoles: ['super_admin'],
        },
        {
          title: 'Kullanıcı Yönetimi',
          url: '/kullanicilar',
          icon: IconUsers,
          allowedRoles: ['super_admin', 'admin'],
        },
      ],
    },
  ],
}
